module.exports = __webpack_public_path__ + "media/loupe.2b042df3.svg";